import { getEnvKey } from "./environment";
import * as PlanIds from './planIds';

export const savedSalesAgentId = 622635;
export const D2CAgentId = 660555;
export const testAgentID = 600539;
export const AgentraToHAgentId = 779234;
export const AWLToHAgentId = 738159;
export const EIPToHAgentId = 816681;
export const EliteToHAgentId = 816681;
export const HealthPlanOneToHAgentId = 820702;
export const RealmToHAgentId = 542167;
export const SQToHAgentId = 542224;
export const SVGToHAgentId = 768925;
export const SpringToHAgentId = 782855;
export const SmartMatchToHAgentId = 782856;

// const SVGTestAgentID = 779026;
export const testAgents = [ testAgentID ]
export const SVGUplines = [
  SVGToHAgentId,
  SpringToHAgentId,
  SmartMatchToHAgentId
]
export const EIPUplines = [
  EIPToHAgentId
]

export const SQUplines = [
  SQToHAgentId
]

export const AWLUplines = [
  AWLToHAgentId.toString()
]

export const nonValidBrightTopOfHierarchyIDs = [
  SVGToHAgentId,
  SpringToHAgentId,
  SmartMatchToHAgentId,
  RealmToHAgentId,
  SQToHAgentId,
  HealthPlanOneToHAgentId,
  AgentraToHAgentId
]

export const nonValidSmileTopOfHierarchyIDs = [
  SVGToHAgentId,
  SpringToHAgentId,
  SmartMatchToHAgentId,
  RealmToHAgentId,
  SQToHAgentId,
  EliteToHAgentId,
  HealthPlanOneToHAgentId,
  AgentraToHAgentId
]

// TODO move this to models/FeatureFlags#getPlanExclusionsForToH
const productExclusionMappings: { [key: number]: number[] } = {
  [AWLToHAgentId]: [PlanIds.NCDBright1500byMetLife, PlanIds.NCDSmile2500byMetLife]
}

// @params agentId - the agentId that may have an entry in productExclusionMappings
// @params planIds - a grouping of planIds to filter
// @returns array of filtered planIds
export const filterPlanIds = (
  agentId: number | undefined,
  agentPlanExclusions: { [key: string]: boolean } | undefined,
  planIds: number[]
): number[] => {
  const theAgentMapping = productExclusionMappings[agentId!];

  const filteredByToH = planIds.filter((planId) => {
    if (!theAgentMapping) {
      return true // no exclusions defined for agentId so we will not filter this planId out
    }
    return !theAgentMapping.includes(planId) // keep planId only if not listed in exclusionMappings
  })

  return filteredByToH.filter((planId) => {
    if(!agentPlanExclusions) return true;

    // keep planId if it is not explicitly in the agentPlansExclusions...otherwise look at that boolean
    if (Object.keys(agentPlanExclusions).includes(`${planId}`)){
      return agentPlanExclusions[planId]
    } else
      return true // true means keep in this collection
  })
}

export const LETTER_ID_DENTAL_DENTALandVISION = "28992";
export const LETTER_ID_VISION_ONLY_OR = "29249";
export const LETTER_ID_VISION_ONLY_DEFAULT = "29248";
export const LETTER_ID_ENROLLMENT_CONFIRMATION = "34545";

// for the purpose of autocompleting, store these in an object
export enum ENV {
  REACT_APP_ADDRESSLOOKUP = 'REACT_APP_ADDRESSLOOKUP',
  REACT_APP_AGENTLOGINLAMBDAURL = 'REACT_APP_AGENTLOGINLAMBDAURL',
  REACT_APP_AGENTLICENSELAMBDAURL = 'REACT_APP_AGENTLICENSELAMBDAURL',
  REACT_APP_API123METLIFE = 'REACT_APP_API123METLIFE',
  REACT_APP_AWS_RUM_APP_ID = 'REACT_APP_AWS_RUM_APP_ID',
  REACT_APP_MEMBERAPIKEY = 'REACT_APP_MEMBERAPIKEY',
  REACT_APP_SESSIONIDLAMBDAURL = 'REACT_APP_SESSIONIDLAMBDAURL',
  REACT_APP_BANNER = 'REACT_APP_BANNER',
  REACT_APP_SMARTYSTREETS = 'REACT_APP_SMARTYSTREETS',
  REACT_APP_SVGBILLINGDATECHECK = 'REACT_APP_SVGBILLINGDATECHECK',
  REACT_APP_VALIDATECCURL = 'REACT_APP_VALIDATECCURL',
  REACT_APP_ZIPCODELOOKUP = 'REACT_APP_ZIPCODELOOKUP'
}

// following naming conventions of Namespace-Capitalized-Kabob-Case
export const CUSTOM_HEADERS = {
  agentId: 'NCD-Agent-Id',
  sessionId: 'NCD-Session-Id',
  xApiKey: 'X-Api-Key'
}
export const buildNCDHeaders = (agentId?: string | number, sessionId?: string) => {
  return {
    [CUSTOM_HEADERS.agentId]: agentId,
    [CUSTOM_HEADERS.sessionId]: sessionId
  }
}

export const states = [
  {
    name: "Alabama",
    abbreviation: "AL",
  },
  {
    name: "Alaska",
    abbreviation: "AK",
  },
  {
    name: "Arizona",
    abbreviation: "AZ",
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
  },
  {
    name: "California",
    abbreviation: "CA",
  },
  {
    name: "Colorado",
    abbreviation: "CO",
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
  },
  {
    name: "Delaware",
    abbreviation: "DE",
  },
  {
    name: "District Of Columbia",
    abbreviation: "DC",
  },
  {
    name: "Florida",
    abbreviation: "FL",
  },
  {
    name: "Georgia",
    abbreviation: "GA",
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
  },
  {
    name: "Idaho",
    abbreviation: "ID",
  },
  {
    name: "Illinois",
    abbreviation: "IL",
  },
  {
    name: "Indiana",
    abbreviation: "IN",
  },
  {
    name: "Iowa",
    abbreviation: "IA",
  },
  {
    name: "Kansas",
    abbreviation: "KS",
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
  },
  {
    name: "Maine",
    abbreviation: "ME",
  },
  {
    name: "Maryland",
    abbreviation: "MD",
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
  },
  {
    name: "Michigan",
    abbreviation: "MI",
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
  },
  {
    name: "Missouri",
    abbreviation: "MO",
  },
  {
    name: "Montana",
    abbreviation: "MT",
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
  },
  {
    name: "Nevada",
    abbreviation: "NV",
  },
  {
    name: "New Hampshire",
    abbreviation: "NH",
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
  },
  {
    name: "New York",
    abbreviation: "NY",
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
  },
  {
    name: "Ohio",
    abbreviation: "OH",
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
  },
  {
    name: "Oregon",
    abbreviation: "OR",
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
  },
  {
    name: "Texas",
    abbreviation: "TX",
  },
  {
    name: "Utah",
    abbreviation: "UT",
  },
  {
    name: "Vermont",
    abbreviation: "VT",
  },
  {
    name: "Virginia",
    abbreviation: "VA",
  },
  {
    name: "Washington",
    abbreviation: "WA",
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
  },
];

export function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

export function formatDateString(dateString: string) {
  return dateString.replaceAll("-", "/");
}

/**
 * Formats a date in MM/DD/YYYY format using the user's local timezone
 *
 * IMPORTANT: This function intentionally uses local time for user-facing dates
 * like billing dates and effective dates. For business rules that should be
 * enforced at the same moment across all timezones (like product visibility),
 * use toCentralTime() from datetime_utils.ts instead.
 *
 * @param date - The date to format
 * @returns {string} - Date formatted like "04/19/2025" in local timezone
 */
export function formatDate(date: Date) {
  return [
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
    date.getFullYear(),
  ].join("/");
}

/**
 * Formats a date in YYYY-MM-DD format using the user's local timezone
 *
 * Note: This format converts to UTC if passed to new Date() without a time component,
 * which may lead to a different date depending on the user's timezone
 *
 * @param date - The date to format
 * @returns {string} - Date formatted like "2025-05-01" in local timezone
 */
function formatDateYmd(date: Date) {
  return `${date.getFullYear()}-${padTo2Digits(date.getMonth() + 1)}-${padTo2Digits(date.getDate())}`;
}

export function getFirstDayOfMonth(year: number, month: number) {
  return new Date(year, month, 1);
}

export function displayDate(dateToDisplay: string) {
  let date = new Date(dateToDisplay);
  date = new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000));
  return date;
}

/**
 * Returns the minimum allowed billing date (today's date) in the user's local timezone
 *
 * @returns {string} Today's date formatted for user display in local timezone
 */
export function getMinDateBilling() {
  // Use local timezone for user-facing dates
  return formatDate(new Date());
}

/**
 * Calculates the maximum billing date based on monthsToAdd in the user's local timezone
 * Handles timezone offset to ensure consistent date logic
 *
 * @param monthsToAdd - Number of months to add to today's date
 * @returns {Date} Maximum billing date as a Date object
 */
function getMaxDateBillingDate(monthsToAdd: number): Date {
  const today = new Date();
  const timezoneOffset = new Date().getTimezoneOffset() / 60
  let maxDate: Date;
  // we want the billingDate to be the day _before_ the 1st of the month...which will be a valid effectiveDate
  if (timezoneOffset === 0) {
    // last argument as 0 selects the day before the 1st day of the month
    maxDate = new Date(today.getFullYear(),today.getMonth() + monthsToAdd,0);
  } else {
    // datePicker and functions like getDate will convert to local time and drag this date back by one day...
    maxDate = new Date(today.getFullYear(),today.getMonth() + monthsToAdd,1);
  }
  return maxDate;
}

/**
 * Returns the maximum billing date as a string in the user's local timezone
 *
 * @param monthsToAdd - Number of months to add to today's date
 * @returns {string} Maximum billing date formatted as YYYY-MM-DD
 */
export function getMaxDateBilling(monthsToAdd: number): string {
  getMaxDateBillingDate(monthsToAdd)
  // YYYY-mm-dd format converts to "UTC". Depending on system local time zone, this value may change -1 day.
  return formatDateYmd(getMaxDateBillingDate(monthsToAdd));
}

/**
 * Calculates the maximum effective date (usually 1st of month) in the user's local timezone
 *
 * @param monthsToAdd - Number of months to add to today's date
 * @returns {Date} Maximum effective date as a Date object
 */
export function getMaxDateEffective(monthsToAdd: number): Date {
  const today = new Date();
  const timezoneOffset = new Date().getTimezoneOffset() / 60
  let maxDate: Date;
  // we want the effectiveDate to be the 1st of the month
  if (timezoneOffset === 0) {
    // last argument as 1 selects the 1st of the month
    maxDate = new Date(today.getFullYear(),today.getMonth() + monthsToAdd,1);
  } else {
    // datePicker and functions like getDate will convert to local time and drag this date back by one day...
    maxDate = new Date(today.getFullYear(),today.getMonth() + monthsToAdd,2);
  }
  return maxDate;
}

export function getMaxDate() {
  let currentDate = new Date();
  let maxYear = currentDate.getFullYear() - 18;
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();
  return maxYear + "-" + padTo2Digits(month) + "-" + padTo2Digits(day);
}

export function getMaxDateChildren() {
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  let monthString = "";
  let dayString = "";
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();
  if (month < 10) monthString = "0" + month.toString();
  else monthString = month.toString();
  if (day < 10) dayString = "0" + day.toString();
  else dayString = day.toString();
  return currentDate.getFullYear() + "-" + monthString + "-" + dayString;
}

export function getMinDate() {
  let currentDate = new Date();
  let monthString = "";
  let dayString = "";
  let maxYear = currentDate.getFullYear() - 26;
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate() + 1;
  if (month < 10) monthString = "0" + month.toString();
  else monthString = month.toString();
  if (day < 10) dayString = "0" + day.toString();
  else dayString = day.toString();
  return maxYear + "-" + monthString + "-" + dayString;
}

export function dateIsValid(date?: string) {
  if (!date) return false;
  return !Number.isNaN(new Date(date).getTime());
}

export function formatPhoneNumber(phoneNumber?: string) {
  let cleaned = ("" + phoneNumber).replace(/\D/g, "");
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + "-" + match[2] + "-" + match[3];
  }
  return null;
}

// @param date {string} - the billing date (likely on the member instance)
// @return value {boolean} - check if today <= billing date
export function isBillingCurrent(date?: string) {
  // Case 1 - date is undefined
  if (!date) return false;

  // Case 2 - date is defined
  let today = new Date();
  let billing = new Date(date);
  today.setHours(0, 0, 0, 0);

  let value = today <= billing;

  return value;
}

// nonValidDentalStates arrays:
// note that inclusion in nonValidDentalStates means the following more specific arrays won't do anything

export const nonValidDentalStates = [
  "AK",
  "ME",
  "MT",
  //"NC",
  "SD",
  "VT",
  "WA",
];


// CORE = value, essentials, complete
export const nonValidCoreStates: string[] = []

export const nonValidEliteStates: string[] = [
  "AK",
  "ME",
  "MT",
  "SD",
  "VT",
  "WA",
];

export const nonValidBrightStates: string[] = [
  "AK",
  "CT",
  "ME",
  "MT",
  "NM",
  "NY",
  "SD",
  "UT",
  "VT",
  "WA",
]

export const nonValidSmileStates: string[] = [
  "AK",
  "CT",
  "LA",
  "ME",
  "MS",
  "MT",
  "NV",
  "NY",
  "SD",
  "TX",
  "UT",
  "VT"
]
// END nonValidDentalStates

export const nonValidVisionStates: string[] = ["OR"];

export const noSalesState: string[] = ["WA"];

export const noSalesStateD2C: string[] = [];

export const sessionIDLambdaURL = `${process.env.REACT_APP_SESSIONIDLAMBDAURL}`;
export const E123ApiURL = `${process.env.E123APIURL}`;
export const memberCreateErrorHandlerZapierWebhookURL = `${process.env.MEMBERCREATEERRORHANDLERZAPIERWEBHOOKURL}`;
export const d2cWebhook = `${process.env.D2CWEBHOOK}`;
export const middlewareV1Hook = `${process.env.MIDDLEWAREV1HOOK}`;
export const middlewareV1_5Hook = `${process.env.MIDDLEWAREV1_5HOOK}`;
export const svgBillingDateCheck = getEnvKey(ENV.REACT_APP_SVGBILLINGDATECHECK);

export const dentalPlansIDs = [
  PlanIds.NCDValueByMetLife,
  PlanIds.NCDEssentialsByMetLife,
  PlanIds.NCDCompleteByMetLife,
  PlanIds.NCDElite1500,
  PlanIds.NCDElite3000,
  PlanIds.NCDElite5000,
  PlanIds.NCDSmile1000byMetLife,
  PlanIds.NCDSmile2500byMetLife,
  PlanIds.NCDBright1000byMetLife,
  PlanIds.NCDBright1500byMetLife,
];

export const dentalPlansIDsNYCT = [
  PlanIds.NCDValueByMetLifeNYCT,
  PlanIds.NCDEssentialsByMetLifeNYCT,
  PlanIds.NCDCompleteByMetLifeNYCT,
  PlanIds.NCDElite1500,
  PlanIds.NCDElite3000,
  PlanIds.NCDElite5000,
  PlanIds.NCDSmile1000byMetLife,
  PlanIds.NCDSmile2500byMetLife,
  PlanIds.NCDBright1000byMetLife,
  PlanIds.NCDBright1500byMetLife,
];

export const dentalAssociationPlansIDs = [PlanIds.NWFA_Low_Dental, PlanIds.NWFA_Mid_High_Dental];

export const visionPlanIDs = [PlanIds.VSPPreferredByMetLife];
export const visionPlanIDsForNonValidStates = [PlanIds.VSPextra];
export const visionAssociationPlansIDs = [PlanIds.NWFA_VSP_Only];

export const bundleAssociationPlansIDs = [PlanIds.NWFA_Low_Combo, PlanIds.NWFA_Mid_High_Combo];

export const validDentalAndValidVisionSteps = [
  "Start",
  "Dental Coverage",
  "Vision Coverage",
  "Amount of Dependents",
  "Dental",
  "Confirm Cart",
  "Primary",
  "Dependents",
  "Payment",
  "Confirmation",
  "Agreements",
  "Completed",
];

export const validDentalAndNoValidVisionSteps = [
  "Start",
  "Dental Coverage",
  "Vision Coverage",
  "Amount of Dependents",
  "Dental",
  "Confirm Cart",
  "Primary",
  "Dependents",
  "Payment",
  "Confirmation",
  "Agreements",
  "Completed",
];

export const notValidDentalAndValidVisionSteps = [
  "Start",
  "Vision Coverage",
  "Amount of Dependents",
  "Confirm Cart",
  "Primary",
  "Dependents",
  "Payment",
  "Confirmation",
  "Agreements",
  "Completed",
];

export const notValidDentalAndNotValidVisionSteps = [
  "Start",
  "Vision Coverage",
  "Amount of Dependents",
  "Confirm Cart",
  "Primary",
  "Dependents",
  "Payment",
  "Confirmation",
  "Agreements",
  "Completed",
];

export const somethingWentWrong = (isD2C: boolean, action: string = '') => {
  const supportPhone = isD2C ? NCD_MEMBER_CARE_PHONE : NCD_AGENT_SUPPORT_PHONE;
  action = (action.length > 0) ? action : 'while processing this request';
  const supportTeamName = isD2C ? 'Member Care Team' : 'Agent Support Team';
  return `Something went wrong ${action}. Please try again. If the issue persists please reach out to our ${supportTeamName}. ${supportPhone}`;
}

export const ZIP_CODE_VALID_LENGTH_MSG = 'Zip code must be 5 characters long';
export const INVALID_ZIP_CODE_MSG = 'Invalid zip code';
export const STATE_NOT_AVAILABLE_MSG = 'State is not available';


export const NCD_AGENT_SUPPORT_PHONE = '1-844-284-4944';
export const NCD_AGENT_SUPPORT_TRACK_INVALID_PHONE = '833-289-8864';
export const NCD_MEMBER_CARE_PHONE = '1-800-485-3855';
export const NCD_WELCOME_TEAM_EMAIL = 'welcometeam@ncd.com';
export const NCD_MEMBER_CARE_EMAIL = 'membercare@ncd.com';
export const NCD_APP_TECH_SUPPORT = 'AppTechSupport@NCD.com';

// Banner utility functions
export const parseBannerContent = (bannerEnvVar?: string): { title: string; subtitle: string } | null => {
  if (!bannerEnvVar || bannerEnvVar.trim() === '') return null;

  const parts = bannerEnvVar.split('|');
  if (parts.length < 2) return null;

  return {
    title: parts[0].trim(),
    subtitle: parts[1].trim()
  };
};

export const hideBannerForAgent = (agentId?: number): boolean => {
  if (!agentId) return false;

  // Agent IDs that should never see the coming soon banner
  const excludedAgentIds = [D2CAgentId]; // 660555

  return excludedAgentIds.includes(agentId);
};

export const shouldShowBanner = (agentId?: number): boolean => {
  const bannerContent = getEnvKey(ENV.REACT_APP_BANNER);

  // Assign guard clause results to variables
  const hasContent = bannerContent && bannerContent.trim() !== '' && bannerContent !== 'null';
  const canParse = hasContent ? !!parseBannerContent(bannerContent) : false;
  const isAgentExcluded = hideBannerForAgent(agentId);

  // Return false if any guard clause fails
  if (!hasContent || !canParse || isAgentExcluded) {
    return false;
  }

  return true;
};
